import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "goods_show"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "goods_ct"
};
const _hoisted_4 = {
  class: "goods_info"
};
const _hoisted_5 = {
  class: "goods_title"
};
const _hoisted_6 = {
  class: "goods_buy"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  class: "cart_btn"
};
const _hoisted_9 = {
  class: "goods_att"
};
const _hoisted_10 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_van_stepper = _resolveComponent("van-stepper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
    title: "商品详情",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createVNode(_component_van_swipe, {
    class: "goods_swipe",
    autoplay: 3000
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods.thumb, thumb => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: thumb
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: thumb
        }, null, 8, _hoisted_2)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($setup.goods.title), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("dl", null, [_createElementVNode("dt", null, "￥" + _toDisplayString($setup.goods.price) + "/" + _toDisplayString($setup.goods.unit), 1), $setup.cartList[$setup.goods.id] ? (_openBlock(), _createElementBlock("dd", _hoisted_7, [_createVNode(_component_van_stepper, {
    modelValue: $setup.cartList[$setup.goods.id].count,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.cartList[$setup.goods.id].count = $event),
    step: $setup.goods.step_no,
    min: "0",
    name: $setup.goods.id,
    onChange: $setup.editCart,
    onMinus: _cache[1] || (_cache[1] = $event => $setup.delCart($setup.goods.id, $setup.goods.less_no)),
    "disable-input": ""
  }, null, 8, ["modelValue", "step", "name", "onChange"])])) : (_openBlock(), _createElementBlock("dd", _hoisted_8, [_createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = $event => $setup.addCart($setup.goods.id, $setup.goods.less_no))
  }, "加入购物车")]))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("ul", null, [_createElementVNode("li", null, "商品规格：" + _toDisplayString($setup.goods.spec), 1), _createElementVNode("li", null, "储存条件：" + _toDisplayString($setup.goods.storage), 1), _createElementVNode("li", null, "保质期：" + _toDisplayString($setup.goods.quality), 1), _createElementVNode("li", null, _toDisplayString($setup.goods.describe), 1)])])]), _createElementVNode("div", {
    class: "goods_xq",
    innerHTML: $setup.goods.content
  }, null, 8, _hoisted_10)])]);
}